@if (toonSymbool()) {
    <div class="simfeedback-container node-dom-icon-container">
        <div class="simfeedback animatie node-dom-icon"
             (pointerenter)="mouseInIcon()"
             (pointerleave)="mouseOutIcon()">
            <span [class.animeer]="animeer()" (animationend)="animatieKlaar()">!</span>
            <span class="numregels">{{ numMeldingen() }}</span>
        </div>
    </div>
}
@if (dlgOpen()) {
    <dl-node-dom-ballon [anker]="getAnker()"
                         (hoverIn)="bijDlgIn()" (hoverOut)="bijDlgUit()">
        <div class="tekst">{{ getDlgTekst() }}</div>
        <div class="bouwsuggestie_btns">
            <div (click)="klikSluiten()">{{ 'BOUWSUGGESTIE.SLUIT' | translate }}</div>
            <div (click)="klikVorige()" [style.visibility]="kanVorige() ? '' : 'hidden'">{{ 'BOUWSUGGESTIE.VORIGE' | translate }}</div>
            <div (click)="klikVolgende()" [style.visibility]="numMeldingen() > 1 ? '' : 'hidden'">{{ 'BOUWSUGGESTIE.VOLGENDE' | translate }}</div>
        </div>
    </dl-node-dom-ballon>
}
